export type ScoreDimension = 'language' | 'settings' | 'brand' | 'brief'

export type RuleFinding = {
  label: string
  explanation: string
  offendingText?: string | null
  suggestion?: string | null
}

export type ToneFinding = {
  name: string
  score: number
  explanation: string
}

export type VariantScore = {
  copy: string
  experimentName?: string
  overall: number
  language?: {
    score: number
    fluency?: { score: number; explanation: string }
    findings: RuleFinding[]
  }
  settings?: {
    score: number
    applicable: number
    passed: number
    failed: number
    findings: RuleFinding[]
  }
  brand?: {
    score: number
    tones: ToneFinding[]
  }
  brief?: {
    score: number
    explanation: string
  }
}

export type ScoreMode = 'generate' | 'pregenerated'

export const DIMENSION_LABELS: Record<ScoreDimension, string> = {
  language: 'Language quality',
  settings: 'Config adherence',
  brand: 'Brand alignment',
  brief: 'Brief adherence',
}

export const DIMENSION_COLORS: Record<ScoreDimension, string> = {
  language: '#534AB7',
  settings: '#BA7517',
  brand: '#185FA5',
  brief: '#0F6E56',
}

export const HEALTH_LEVELS = [
  { min: 88, label: 'Excellent', className: 'bg-green-100 text-green-800' },
  { min: 74, label: 'Good', className: 'bg-lime-100 text-lime-800' },
  { min: 55, label: 'Needs work', className: 'bg-amber-100 text-amber-800' },
  { min: 0, label: 'Poor', className: 'bg-red-100 text-red-800' },
] as const

export const getHealthLevel = (score: number) => {
  return (
    HEALTH_LEVELS.find((level) => score >= level.min) ??
    HEALTH_LEVELS[HEALTH_LEVELS.length - 1]
  )
}
